import { render, staticRenderFns } from "./substance_model_management.vue?vue&type=template&id=703d16fa&scoped=true&"
import script from "./substance_model_management.vue?vue&type=script&lang=js&"
export * from "./substance_model_management.vue?vue&type=script&lang=js&"
import style0 from "./substance_model_management.vue?vue&type=style&index=0&id=703d16fa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703d16fa",
  null
  
)

export default component.exports